
<div id="confirmation-dialog-component" [class]="dialogClass">
    <kendo-dialog title="{{confirmDialog.title}}" *ngIf="confirmDialog?.opened" (close)="CloseDialog()" [minWidth]="250" [width]="width" [class]="dialogClass">
        <p [innerHTML]="confirmDialog.message" style="text-align: left;"></p>
        <div class="d-flex">
            <div (keydown.enter)="close(false)">
                <outlined-btn class="no-btn pointer" (click)="close(false)" text="{{confirmDialog.cancelText}}"></outlined-btn>&nbsp;
            </div>
            <div class="mr-2" (keydown.enter)="close(true)">
                <contained-btn class="yes-btn pointer" (click)="close(true)" primary="true" text="{{confirmDialog.confirmText}}"></contained-btn>
            </div>
        </div>
       
    </kendo-dialog>
  </div>